/**
 * Favorite Location Card Component
 * 
 * Displays a single favorite location with its preferences
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaEdit, FaTrash, FaHome, FaBriefcase, FaDumbbell, FaMapMarkerAlt } from 'react-icons/fa';
import './FavoriteLocationCard.css';

const FavoriteLocationCard = ({ location, onEdit, onDelete }) => {
  const { t } = useTranslation('common');
  
  // Get icon based on label
  const getIcon = (label) => {
    const lowerLabel = label.toLowerCase();
    if (lowerLabel.includes('home') || lowerLabel.includes('mājas') || lowerLabel.includes('дом')) return <FaHome />;
    if (lowerLabel.includes('work') || lowerLabel.includes('darbs') || lowerLabel.includes('работ')) return <FaBriefcase />;
    if (lowerLabel.includes('gym') || lowerLabel.includes('sporta') || lowerLabel.includes('спорт')) return <FaDumbbell />;
    return <FaMapMarkerAlt />;
  };

  return (
    <div className="favorite-location-card">
      <div className="location-card-header">
        <div className="location-icon">
          {getIcon(location.label)}
        </div>
        <div className="location-info">
          <h4 className="location-label">{location.label}</h4>
          <p className="location-address">{location.address}</p>
          {location.city && <p className="location-city">{location.city}</p>}
        </div>
        <div className="location-actions">
          <button
            className="location-action-btn edit-btn"
            onClick={() => onEdit(location)}
            title={t('buttons.edit')}
          >
            <FaEdit />
          </button>
          <button
            className="location-action-btn delete-btn"
            onClick={() => onDelete(location.id)}
            title={t('buttons.delete')}
          >
            <FaTrash />
          </button>
        </div>
      </div>

      <div className="location-card-details">
        <div className="location-detail-item">
          <span className="detail-label">📏 {t('settings.radius')}:</span>
          <span className="detail-value">{location.radius_km}km</span>
        </div>

        <div className="location-detail-item">
          <span className="detail-label">🎯 {t('settings.match_type')}:</span>
          <span className="detail-value">
            {location.match_start_point && location.match_end_point && t('settings.start_and_end')}
            {location.match_start_point && !location.match_end_point && t('settings.start_only')}
            {!location.match_start_point && location.match_end_point && t('settings.end_only')}
            {!location.match_start_point && !location.match_end_point && 'None'}
          </span>
        </div>

        <div className="location-detail-item">
          <span className="detail-label">📢 {t('settings.notify_for')}:</span>
          <span className="detail-value">
            {location.notify_for_rides && location.notify_for_packages && '🚗📦 ' + t('settings.both_rides_packages')}
            {location.notify_for_rides && !location.notify_for_packages && '🚗 ' + t('settings.rides_only')}
            {!location.notify_for_rides && location.notify_for_packages && '📦 ' + t('settings.packages_only')}
            {!location.notify_for_rides && !location.notify_for_packages && 'None'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default FavoriteLocationCard;
